import React from 'react';

export const DiamondFilled = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.23744 1.22655C8.55402 0.543136 7.44598 0.543134 6.76256 1.22655L1.22656 6.76256C0.54314 7.44598 0.543138 8.55401 1.22656 9.23743L6.76256 14.7734C7.44598 15.4569 8.55402 15.4569 9.23744 14.7734L14.7734 9.23743C15.4569 8.55402 15.4569 7.44598 14.7734 6.76256L9.23744 1.22655ZM11.0755 6.16351C11.3321 6.41453 11.3366 6.82607 11.0856 7.08269L7.72113 10.5223C7.59884 10.6473 7.43134 10.7177 7.25646 10.7177C7.08159 10.7177 6.91409 10.6473 6.7918 10.5223L4.91438 8.60294C4.66335 8.34632 4.66789 7.93478 4.92452 7.68376C5.18115 7.43273 5.59268 7.43728 5.8437 7.6939L7.25646 9.13819L10.1563 6.17365C10.4073 5.91703 10.8188 5.91248 11.0755 6.16351Z"
      fill="#4C43AA"
    />
  </svg>
);
